import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import { persistor } from '../store';
import Main from './Main';
import { initialize } from './appSlice';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
  }, [dispatch]);
};

const App = () => {
  const dispatch = useDispatch();
  const { initializing, initialized, initError } = useSelector(
    state => state.appPeerAgencies,
  );
  useInitialize(dispatch);
  return useMemo(() => {
    if (initError) {
      return <ErrorPage persistor={persistor} />;
    }

    if (initializing) {
      return <AppLoading />;
    }

    if (initialized) {
      return <Main />;
    }

    return <ErrorPage persistor={persistor} />;
  }, [initializing, initialized, initError]);
};

export default App;
